wow = new WOW({
    animateClass: "animated",
    offset: 100,
    callback: function (box) {
        box.classList.add("animBox");
    },
});
wow.init();

function startCountingOnScroll() {
    const counters = document.querySelectorAll('[data-counter]'); // Select all elements with the data-counter attribute

    const handleScroll = () => {
        counters.forEach(counterElement => {
            const rect = counterElement.getBoundingClientRect();
            const started = counterElement.dataset.started === "true";

            if (!started && rect.top <= window.innerHeight && rect.bottom >= 0) {
                const start = parseInt(counterElement.dataset.start || "1", 10);
                const end = parseInt(counterElement.dataset.end || "1000", 10);
                const interval = 10;
                const anim_incriment = parseInt(counterElement.dataset.increment || "1", 10);
                let current = start;

                counterElement.dataset.started = "true"; // Mark this element as started

                const intervalId = setInterval(() => {
                    counterElement.textContent = current;

                    if (current >= end) {
                        clearInterval(intervalId);
                    } else {
                        current =  parseInt(anim_incriment) + parseInt(current);
                    }
                }, interval);
            }
        });
    };

    window.addEventListener('scroll', handleScroll);
}
startCountingOnScroll();


$('.accordion-title').click(function (event) {
    event.preventDefault(); // Prevent default action of the button/link

    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).closest('.accordian-section').find('.accordion-content').slideUp();
    } else {
        
        $(this).closest('.accordian-section').find('.accordion-title').removeClass('active');
        $(this).closest('.accordian-section').find('.accordion-content').slideUp();
        $(this).addClass('active');
       $(this).closest('.accordian-box').find('.accordion-content').slideDown();
    }
    
    
    // Toggle the active class and content for the clicked element
    
});


var swiper = new Swiper(".main-menu-swiper",{
    slidesPerView:"auto",
    spaceBetween:0,
    mousewheel:true,
    allowTouchMove:true,
    loop:false,
    autoplay:false
})